{
    "type": "object",
    "properties": {
        "email": {
            "required": true,
            "type": "email",
            "title": "Email",
            "validationMessages": {
                "required": "Enter Email",
                "email": "Enter valid Email"
            }
        }  
    }
}
